document.addEventListener('DOMContentLoaded', () => {
  const $ingredientsBlocks = Array.from(document.querySelectorAll('.ingredients-module'))
  if ($ingredientsBlocks.length) {
    for (const $ingredientsBlock of $ingredientsBlocks) {
      const allImgElem = $ingredientsBlock.querySelectorAll('.ingredients-module__image img')
      const items = $ingredientsBlock.querySelectorAll('.ingredients-module__item')
      items.forEach((item) => {
        item.addEventListener('mouseenter', event => {
          const imgElem = $ingredientsBlock.querySelector(`.ingredients-module__image-${item.dataset.index}`)
          allImgElem.forEach((img) => img.classList.add('transparent'))
          imgElem.classList.remove('transparent')
        })
      })
    }
  }
})
